
export const marketplaces = [
  { label: 'US', key: 'US' },
  { label: 'CA', key: 'CA' },
  { label: 'MX', key: 'MX' },
  { label: 'UK', key: 'UK' },
  { label: 'DE', key: 'DE' },
  { label: 'FR', key: 'FR' },
  { label: 'IT', key: 'IT' },
  { label: 'ES', key: 'ES' },
]

export const unitTestType = {
  FULFILLMENT: 'fulfillment-fee',
  MONTHLYANDLTS: 'monthly-and-long-term-storage-fee',
  SIZETIERSANDSHIPWGT: 'size-tiers-and-shipping-weight',
  REFERRAL: 'referral-fee',
}

export const xPathTabs = [
  { key: "CategoryXPath", label: "Category X-Path" },
  { key: "ProductXPath", label: "Product X-Path" },
]